import { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { criarAlerta } from 'actions'
import { useVestigioService } from 'hooks/useVestigioService'
import { useExameIdentificacaoBalisticaService } from 'hooks/useExameIdentificacaoBalisticaService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import useRouter from 'utils/useRouter'

export const useExameIdentificacaoBalistica = (tipoExame) => {
  const params = useParams()
  const dispatch = useDispatch()
  const router = useRouter()
  
  const vestigioService = useVestigioService()
  const exameIdentificacaoService = useExameIdentificacaoBalisticaService()
  const exameRealizadoService = useExameRealizadoService()
  
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [processandoAlteracaoRespostas, setProcessandoAlteracaoRespostas] = useState(false)
  const [tiposVestigios, setTiposVestigios] = useState([])
  const [tiposVestigiosEspecificos, setTiposVestigiosEspecificos] = useState([])
  const [respostasQuesitos, setRespostasQuesitos] = useState()
  const [atualizado, setAtualizado] = useState(false)

  const fetchTiposVestigios = useCallback(async () => {
    const response = await vestigioService.listarTiposVestigiosAsync(setProcessandoOperacao)
    setTiposVestigios(response)
  }, [])

  const fetchTiposVestigiosEspecificos = useCallback(async () => {
    const response = await vestigioService.listarTiposVestigiosEspecificosAsync(setProcessandoOperacao)
    setTiposVestigiosEspecificos(response)
  }, [])

  const fetchExameIdentificacao = useCallback(async () => {
    if (params.idExameRealizado) {
      const response = await exameIdentificacaoService.listarExameIdentificacaoAsync(params.idExameRealizado)
      if (!response) {
        dispatch(
          criarAlerta(
            { status: 501 },
            router,
            `/casos/caso/solicitacao/exameSolicitado/detalhar/${params.idExameSolicitado}`
          )
        )
      }
    }
  }, [params.idExameRealizado, params.idExameSolicitado, dispatch, router])

  useEffect(() => {
    fetchTiposVestigios()
  }, [fetchTiposVestigios])

  useEffect(() => {
    fetchTiposVestigiosEspecificos()
  }, [fetchTiposVestigiosEspecificos])

  useEffect(() => {
    fetchExameIdentificacao()
  }, [fetchExameIdentificacao])

  const handleFinalizarExame = useCallback(async () => {
    await exameRealizadoService.alterarRespostas({ respostasQuesitos }, setProcessandoAlteracaoRespostas)
    await exameRealizadoService.gerarDocumento(params.idExameRealizado, setProcessandoAlteracaoRespostas)
    router.history.push({
      pathname: `/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${params.idExameRealizado}`,
      state: { IgnoneUploadImagem: true, tipoExame },
    })
  }, [respostasQuesitos, params.idExameRealizado, router, tipoExame])

  return {
    params,
    processandoAlteracaoRespostas,
    respostasQuesitos,
    setRespostasQuesitos,
    setAtualizado,
    handleFinalizarExame,
    router,
  }
}
